import React from 'react'
import { signIn } from 'next-auth/react'

import useTranslation from 'next-translate/useTranslation'
import { useForm } from 'react-hook-form'
import Link from 'next/link'
import FormInput from '../atoms/Form/FormInput'
import Button from '../atoms/Button'

type FormData = {
  email: string
  password: string
}

type ErrorMessage = {
  error: String
}

type SignInError = {
  field: String
  messages: ErrorMessage[]
}

const LoginUserForm = () => {
  const { t } = useTranslation('common')

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm()

  const onSubmit = async (data: FormData) => {
    const { email, password } = data
    const error = await signIn('user_email_password', {
      redirect: false,
      email,
      password,
    })

    if (error && error.error) {
      const obj = JSON.parse(error.error) as SignInError
      const [errorField, errorValue] = Object.entries(obj)[0]
      const errorMessage = errorValue[0] as ErrorMessage

      setError(errorField, {
        message: t(`validation_messages:${errorMessage.error}`),
      })
    }
  }

  return (
    <form
      onSubmit={handleSubmit(async (data) => {
        try {
          await onSubmit(data as FormData)
        } catch (e) {
          // @ts-ignore
          Sentry && Sentry.captureMessage(e.toString())
        }
      })}
    >
      <FormInput
        errors={errors}
        isActive={{}}
        options={{ ...register('email', { required: true }) }}
        required
        label={t('common:email')}
      />
      <FormInput
        errors={errors}
        isActive={{}}
        options={{ ...register('password', { required: true }) }}
        required
        label={t('common:password')}
        type='password'
      />
      {errors.account && (
        <p className='text-sm font-normal text-error' role='alert'>
          {errors.account.message}
        </p>
      )}
      <div className='flex justify-end pb-6'>
        <Link
          href='/auth/user_recover_password'
          prefetch={false}
          className='font-medium text-sm underline hover:no-underline'
        >
          {t('common:not_remember_password')}
        </Link>
      </div>
      <div className='flex flex-wrap justify-between'>
        <input
          type='submit'
          value={t('common:user_signin_button')}
          className='primary xs:w-full sm:w-auto focus:outline-none transition ease-in-out duration-300 cursor-pointer rounded-full  whitespace-nowrap relative inline-block py-2 px-9 text-base bg-primary hover:bg-primary-hover text-white border-3 border-primary hover:border-primary-hover font-normal'
        />
        <Button
          href='/auth/sign_up'
          size='normal'
          type='secondary'
          className='items-center justify-center flex xs:w-full sm:w-auto xs:mt-5 sm:mt-0'
        >
          {t('common:user_signup_button')}
        </Button>
      </div>
    </form>
  )
}

export default LoginUserForm
